import React from 'react';
import TextareaAutoResize from "react-textarea-autosize";

import { mixClasses as cx } from 'helpers';


/*
 * Textarea
 */
const Textarea = ({ className, minRows = 3, ...props }) => (
  <TextareaAutoResize
    className={cx(
      'moa-ff-sans f6 black-70 lh-title',   // typography
      'ba b--light-gray outline-0',     // border
      'pa2',                                // spacing
      className,
    )}
    minRows={minRows}
    {...props}
  />
);


export default Textarea;



// WEBPACK FOOTER //
// ./src/components/elems/Textarea.js